import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ExternalLinkTooltipContent } from "components/Tooltips/ExternalLinkTooltip";
import { Tooltip } from "components/Tooltips/Tooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { getEnvVariable } from "utilities/env";

const env = getEnvVariable("REACT_APP_SENTRY_ENVIRONMENT");

export enum EnvNames {
  PROD = "prod",
  STAGE = "stage",
  QA = "qa",
}

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    versionBadge: {
      borderRadius: "8px",
      padding: theme.spacing(2.5, 5),
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      backgroundColor: () => {
        switch (env) {
          case EnvNames.PROD:
            return theme.green300;
          case EnvNames.STAGE:
            return theme.orange300;
          case EnvNames.QA:
          default:
            return "none";
        }
      },
      fontSize: "13px",
      cursor: "pointer",
    },
  }),
);

export const EnvironmentBadge = () => {
  const classes = useStyles();
  const { message } = useMessage();
  const showBadge = !!(
    env &&
    (env === EnvNames.PROD || env === EnvNames.STAGE)
  );
  if (!showBadge) return null;

  const getBatchContent = () => {
    switch (env) {
      case EnvNames.PROD:
        return {
          title: message({ id: "liveVersion" }),
          desc: message({ id: "liveVersionDesc" }),
        };
      case EnvNames.STAGE:
        return {
          title: message({ id: "stageVersion" }),
          desc: message({ id: "stageVersionDesc" }),
        };
      default:
        return {
          title: "",
          desc: "",
        };
    }
  };

  const { title, desc } = getBatchContent();

  return (
    <Tooltip text={<ExternalLinkTooltipContent name={title} text={desc} />}>
      <div className={classes.versionBadge}>{title}</div>
    </Tooltip>
  );
};
